import { graphql } from "api/cms-website/generated";

import { ResponsiveImageFragment } from "../primitives/responsiveImage";

export const ImageCardItemFragment = graphql(/* GraphQL */ `
    fragment ImageCardItemFragment on ComponentElementsImageCardItem {
        title
        text
        bg {
            ...ResponsiveImageFragment
        }
    }
    ${ResponsiveImageFragment}
`);
